import React, { useRef, useEffect, useState } from 'react';
import Menu from '../../../components/Menu';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import Swal from 'sweetalert2'
import _ from 'lodash';
import Modal from './Modal';
import parse from 'html-react-parser';
import { buscaTransmissao, verificaTransmissao, criaTransmissaoUser, criaPix, buscaPagamento, buscaInformacoes, auditoria, listaUsuarios, listaSalaVip, listaSalaVipConvidados, deletaSalaVip, criaSalaVipConvidado, buscaCupom, criaPagamentoFree } from '../../../services/mysql'
import ModalPix from './ModalPix';
import UsuarioSelect from './UsuarioSelect';

export default function Videos() {
    const queryParams = new URLSearchParams(window.location.search);
    const [id] = useState(queryParams.get('i'))
    const [academia] = useState(queryParams.get('a'))
    const [transmissao, setTransmissão] = useState({})
    const [usuarios, setUsuarios] = useState([])
    const [usuario, setUsuario] = useState({})

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const [isModalOpenPix, setIsModalOpenPix] = useState(false);
    const openModalPix = () => setIsModalOpenPix(true);
    const closeModalPix = () => setIsModalOpenPix(false);
    const [salaVip, setSalaVip] = useState([])

    const [termo, setTermo] = useState('')

    const [urlVideo, setUrlVideo] = useState('')
    const [modalVideo, setModalVideo] = useState(false)
    const [qtdConvidados, setQtdConvidados] = useState(0)
    const [cupom, setCupom] = useState('')
    const [idCupom, setIdCupom] = useState('')
    const [desconto, setDeconto] = useState(0)

    // Pagamento
    const [qrcode, setQrcode] = useState('')
    const [copiaCola, setCopiaCola] = useState('')
    const intervalId = useRef(null);
    const isMobile = window.innerWidth <= 768;


    useEffect(() => {
        mensagemLoading('Buscando Dados dd...')
        const user = JSON.parse(localStorage.getItem('userd7'))
        buscaTransmissao(id).then((res) => {
            if (res.erro) {
                Swal.close()
                mensagemErro('Erro ao buscar vídeos')
            } else {
                Swal.close()
                setTransmissão(res.transmissao)
                const data = {
                    idUsuario: user.id,
                    acao: 'Acessou a página de Transmissão ' + res.transmissao.nome
                }
                auditoria(data);
                listaSalaVipConvidados(
                    { idUser: user.id, idSala: res.transmissao.id, tipo: 'transmissao' }
                ).then((res) => {
                    if (res.erro) {
                        mensagemErro('Erro ao buscar usuarios')
                    } else {
                        setQtdConvidados(res.qtdConvidados)
                        setSalaVip(res.convidados)
                    }
                })
            }
        })
        listaUsuarios().then((res) => {
            if (res.erro) {
                mensagemErro('Erro ao buscar usuarios')
            } else {
                setUsuarios(res)
            }
        })
        buscaInformacoes().then((res) => {
            if (res.erro) {
                Swal.close()
                mensagemErro('Erro ao buscar Informações')
            } else {
                Swal.close()
                setTermo(res[0].termo)
            }
        })
    }, [])

    const startApiCalls = (pagamento, transmissao) => {
        fetchApiData(pagamento, transmissao);
        intervalId.current = setInterval(() => {
            fetchApiData(pagamento, transmissao);
        }, 10000);
    };

    const fetchApiData = async (pagamento, transmissao) => {
        try {
            buscaPagamento(pagamento).then((res) => {
                if (res.status === 'approved') {
                    const user = JSON.parse(localStorage.getItem('userd7'))
                    const data = {
                        idTransmissao: id,
                        idUser: user.id
                    }
                    criaTransmissaoUser(data).then((resTransmissao) => {
                        if (resTransmissao.erro) {
                            mensagemErro('Erro ao gerar transmissaão')
                            const data = {
                                idUsuario: user.id,
                                acao: 'O sistema mostrou erro no pagamento ' + transmissao.nome
                            }
                            auditoria(data);
                        } else {
                            closeModalPix()
                            setUrlVideo(transmissao.canalTransmissao)
                            // openModal()
                            setModalVideo(true)
                            Swal.close()
                            const data = {
                                idUsuario: user.id,
                                acao: 'O sistema aprovou o pagamento e abriu o vídeo para assistir a transmissão ' + transmissao.nome
                            }
                            auditoria(data);
                        }
                    })
                    clearInterval(intervalId.current);
                }
            });
        } catch (err) {
            mensagemErro('Erro ao realizar pagamento');
        }
    };

    function getPlayerUrl(number) {
        const playerLinks = {
            1: "https://delaysp01.logicahost.com.br:5443/tvcompate/play.html?id=tvcombate",
            2: "https://player.logicahost.com.br/player.php?player=1859",
            3: "https://player.logicahost.com.br/player.php?player=1898",
            4: "https://player.logicahost.com.br/player.php?player=1899",
        };

        return playerLinks[number] || null;
    }

    function realizaTransmissao() {
        const user = JSON.parse(localStorage.getItem('userd7'))
        const data = {
            idUsuario: user.id,
            acao: 'Clicou em detalhar a transmissão ' + transmissao.nome
        }
        auditoria(data);
        mensagemLoading('Verificando..')
        verificaTransmissao(user.id, id).then((res) => {
            if (res.erro) {
                mensagemErro('Erro ao verificar transmissao')
                const data = {
                    idUsuario: user.id,
                    acao: 'Gerou erro ao acessar a transmissão ' + transmissao.nome
                }
                auditoria(data);
            } else {
                if (res.transmissao || res.salaVip) {
                    Swal.close()
                    setUrlVideo(transmissao.canalTransmissao)
                    console.log(transmissao)
                    setModalVideo(true)
                    const data = {
                        idUsuario: user.id,
                        acao: 'Acessou a transmissão ' + transmissao.nome + ' pelo canal ' + transmissao.canalTransmissao
                    }
                    auditoria(data);
                } else if (transmissao.free === 'SIM') {
                    const dados = {
                        id_usuario: user.id,
                        id_video: transmissao.id,
                        nome: 'TVCombate - Transmissão',
                        cpf: user.cpf,
                        email: user.email,
                        descricao: 'Transmissao - ' + transmissao.nome,
                        idCupom: null,
                        desconto: parseFloat(0),
                        valor: parseFloat(0),
                        tipo_video: 'transmissao'
                    }
                    criaPagamentoFree(dados).then((res) => {
                        if (res.erro) {
                            mensagemErro('Erro ao entrar na sala')
                        } else {
                            Swal.close()
                            setUrlVideo(transmissao.canalTransmissao)
                            setModalVideo(true)
                        }
                    })
                } else {
                    Swal.fire({
                        title: 'Aviso',
                        text: 'Você precisa realizar o pagamento de ' + (transmissao.valor - parseFloat(desconto)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) + ' para assistir a transmissão ' + transmissao.nome + '! Deseja realizar o pagamento?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Pagar',
                        cancelButtonText: 'Agora Não'
                    }).then((result) => {
                        if (result.value) {
                            const dados = {
                                id_usuario: user.id,
                                id_video: transmissao.id,
                                nome: 'TVCombate - Transmissão',
                                cpf: user.cpf,
                                email: user.email,
                                descricao: 'Transmissao - ' + transmissao.nome,
                                idCupom: idCupom,
                                desconto: parseFloat(desconto),
                                valor: parseFloat(transmissao.valor - parseFloat(desconto)),
                                tipo_video: 'transmissao'
                            }
                            mensagemLoading('Gerando pix..')
                            criaPix(dados).then((res) => {
                                setQrcode(res.data.pagamento.qrcode)
                                setCopiaCola(res.data.pagamento.chave)
                                Swal.close()
                                startApiCalls(res.data.id, transmissao)
                                openModalPix()
                                const data = {
                                    idUsuario: user.id,
                                    acao: 'Gerou o pix da transmissão ' + transmissao.nome
                                }
                                auditoria(data);
                            })
                        }
                    });
                }
            }
        })
    }

    function transmissaoFree() {
        const user = JSON.parse(localStorage.getItem('userd7'))
        const data = {
            idUsuario: user.id,
            acao: 'Clicou em detalhar a transmissão ' + transmissao.nome
        }
        auditoria(data);
        mensagemLoading('Verificando..')
        verificaTransmissao(user.id, id).then((res) => {
            if (res.erro) {
                mensagemErro('Erro ao verificar transmissao')
                const data = {
                    idUsuario: user.id,
                    acao: 'Gerou erro ao acessar a transmissão ' + transmissao.nome
                }
                auditoria(data);
            } else {
                if (res.transmissao || res.salaVip) {
                    Swal.close()
                    setUrlVideo(transmissao.canalTransmissao)
                    console.log(transmissao)
                    // openModal()
                    setModalVideo(true)
                    const data = {
                        idUsuario: user.id,
                        acao: 'Acessou a transmissão ' + transmissao.nome + ' pelo canal ' + transmissao.canalTransmissao
                    }
                    auditoria(data);
                } else {
                    Swal.fire({
                        title: 'Aviso',
                        text: 'Você precisa realizar o pagamento de ' + (transmissao.valor - parseFloat(desconto)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) + ' para assistir a transmissão ' + transmissao.nome + '! Deseja realizar o pagamento?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Pagar',
                        cancelButtonText: 'Agora Não'
                    }).then((result) => {
                        if (result.value) {
                            const dados = {
                                id_usuario: user.id,
                                id_video: transmissao.id,
                                nome: 'TVCombate - Transmissão',
                                cpf: user.cpf,
                                email: user.email,
                                descricao: 'Transmissao - ' + transmissao.nome,
                                idCupom: idCupom,
                                desconto: parseFloat(desconto),
                                valor: parseFloat(transmissao.valor - parseFloat(desconto)),
                                tipo_video: 'transmissao'
                            }
                            mensagemLoading('Gerando pix..')
                            criaPix(dados).then((res) => {
                                setQrcode(res.data.pagamento.qrcode)
                                setCopiaCola(res.data.pagamento.chave)
                                Swal.close()
                                startApiCalls(res.data.id, transmissao)
                                openModalPix()
                                const data = {
                                    idUsuario: user.id,
                                    acao: 'Gerou o pix da transmissão ' + transmissao.nome
                                }
                                auditoria(data);
                            })
                        }
                    });
                }
            }
        })
    }

    function cadastraSala() {
        if (!usuario.id) {
            mensagemAlerta('Selecione um usuário')
            return
        }
        Swal.fire({
            title: 'Aviso',
            text: `Deseja adicionar o usuário ${usuario.nome} como convidados desta transmissão ?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                mensagemLoading('Cadastrando usuário a sala VIP')
                const user = JSON.parse(localStorage.getItem('userd7'))
                const data = {
                    idUsuario: usuario.id,
                    idSala: id,
                    tipo: 'transmissao',
                    idConvidado: user.id,
                }
                criaSalaVipConvidado(data).then((res) => {
                    if (res.erro) {
                        mensagemAlerta(res.msg)
                    } else {
                        mensagemSucessoSalaVip(res.message)
                    }
                })
            }
        });
    }

    function removeSala(item) {
        Swal.fire({
            title: 'Aviso',
            text: 'Deseja remover o usuário ' + item.usuarioNome + ' da sala VIP desta transmissão  ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.value) {
                mensagemLoading('Removendo usuário da sala VIP')
                const data = {
                    idUsuario: item.usuarioId,
                    idSala: id,
                    tipo: 'transmissao'
                }
                deletaSalaVip(data).then((res) => {
                    if (res.erro) {
                        mensagemErro('Erro ao cadastrar usuário na sala vip')
                    } else {
                        mensagemSucessoSalaVip('Usuário adicionado a sala vip com sucesso!')
                    }
                })
            }
        });
    }

    function veirificaCupom() {
        if (!cupom) {
            mensagemAlerta('Por favor digite o cupom')
            return
        }
        buscaCupom(cupom, id).then((res) => {
            if (res.erro) {
                mensagemAlerta(res.msg)
            } else {
                setDeconto(parseFloat(res.dados.valor))
                setIdCupom(res.dados.id)
                mensagemSucesso('Cupom de R$ ' + res.dados.valor + '  aplicado com sucesso!')
            }
        })
    }

    const extractFileIdGoogle = (url) => {
        const regex = /\/d\/(.*?)\//;  // Expressão regular para pegar o ID entre "/d/" e "/"
        const match = url.match(regex);
        return match ? match[1] : null;
    };

    const handleDownload = (urlVideo) => {
        if (!urlVideo) {
            alert('A URL do vídeo é necessária');
            return;
        }

        // Cria dinamicamente um link para fazer a requisição ao backend com a URL do vídeo
        const link = document.createElement('a');
        link.href = `https://app-3prv6jubba-uc.a.run.app/downloadVideo?url=${encodeURIComponent(urlVideo)}`;  // Envia a URL como query parameter

        // Força a abertura da janela de download
        link.target = '_blank';  // Abre o link em uma nova aba (alguns navegadores tratam isso como uma nova ação de download)
        link.download = '';      // O atributo download vazio forçará o diálogo de download para o usuário escolher onde salvar

        // Simula o clique no link para iniciar o download
        document.body.appendChild(link);
        link.click();

        // Remove o link do DOM após o clique
        document.body.removeChild(link);
    };

    function assitirVideo(item) {
        setUrlVideo(item)
        openModal()
    }

    const handleUsuario = (usuario, index) => {
        setUsuario(usuario);
    };

    const handleCupom = (event) => {
        event.persist();
        setCupom(event.target.value);
        if (event.target.value.length === 0) {
            setDeconto(0)
            setIdCupom('')
        }
    }

    // Mensagens
    function mensagemAlerta(msg) {
        Swal.fire('Alerta', msg, 'warning')
    }

    function mensagemErro(msg) {
        Swal.fire('Erro', msg, 'error')
    }
    function mensagemSucesso(msg) {
        Swal.fire('Sucesso', msg, 'success')
    }

    function mensagemSucessoSalaVip(msg) {
        Swal.fire('Sucesso', msg, 'success').then(() => {
            setSalaVip([])
            const user = JSON.parse(localStorage.getItem('userd7'))
            listaSalaVipConvidados(
                { idUser: user.id, idSala: id, tipo: 'transmissao' }
            ).then((res) => {
                if (res.erro) {
                    mensagemErro('Erro ao buscar usuarios')
                } else {
                    setSalaVip(res.convidados)
                }
            })
        })
    }

    function mensagemLoading(msg) {
        Swal.fire({
            title: 'Aguarde',
            html: msg,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
    }
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                {/* <Menu /> */}
                <div class="layout-page">
                    <div>
                        <Header />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 container-p-y">
                                <h3><b>{academia}</b></h3>
                                <button onClick={() => window.location = '/homeAtleta'} style={{ marginTop: 20, width: '30%' }} className="btn btn-primary d-grid " type="submit">{'< Voltar'}</button>
                                {!modalVideo ?
                                    <div className="col-sm-12 col-lg-12 mb-4" style={{ marginTop: 20 }}>
                                        <div className="card card-border-shadow-primary h-100">
                                            {transmissao && transmissao.id ?
                                                <div className="card-body" style={{ alignItems: 'center', textAlign: 'center' }}>
                                                    <img style={{ width: 200, height: 200 }} src={transmissao.urlImagem} />
                                                    <h2 style={{ marginTop: 20 }}>{transmissao.nome}</h2>
                                                    <h5>TERMOS DE ACEITE</h5>
                                                    <p>Versão : v3</p>
                                                    <div>{parse(termo)}</div>
                                                    <p>Valor para assistir esta transmissão</p>
                                                    {transmissao.free === 'SIM' ?
                                                        <h5 ><b>ESSA TRANSMISSÃO É GRATUITA</b></h5>
                                                        :
                                                        <h5 ><b>{(transmissao.valor - parseFloat(desconto)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</b></h5>
                                                    }

                                                    {desconto > 0 ?
                                                        <p style={{ color: 'green' }}>Cupom de {(parseFloat(desconto)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })} aplicado</p>
                                                        :
                                                        null
                                                    }
                                                    {transmissao.free === 'SIM' ?
                                                        <>
                                                            <button onClick={() => realizaTransmissao()} style={{ marginTop: 20 }} className="btn btn-success d-grid w-100" type="submit">
                                                                <i className="menu-icon tf-icons bx bx-video" />Concordar e Assistir Transmissão
                                                            </button>
                                                        </>
                                                        :
                                                        <>
                                                            <div class="mb-3 col-md-12" style={{ textAlign: 'center' }}>
                                                                <label class="form-label" for="basic-icon-default-fullname">Digite o cupom de desconto</label>
                                                                <input value={cupom.toUpperCase()} onChange={handleCupom} type="text" class="form-control" />
                                                            </div>
                                                            <button onClick={() => veirificaCupom()} style={{ marginTop: 20 }} className="btn btn-info d-grid w-100" type="submit">
                                                                <i className="menu-icon tf-icons bx bx-file" />Verificar Cupom
                                                            </button>
                                                            <button onClick={() => realizaTransmissao()} style={{ marginTop: 20 }} className="btn btn-success d-grid w-100" type="submit">
                                                                <i className="menu-icon tf-icons bx bx-video" />Concordar e Assistir Transmissão
                                                            </button>
                                                        </>
                                                    }

                                                </div>
                                                :
                                                null
                                            }

                                        </div>
                                    </div>
                                    :
                                    null
                                }
                                {modalVideo ?
                                    <div className="col-sm-12 col-lg-12 mb-4" style={{ marginTop: 20 }}>
                                        <div className="card card-border-shadow-primary h-100">
                                            {transmissao && transmissao.id ?
                                                <div className="card-body" style={{ alignItems: 'center' }}>
                                                    <div className='row'>
                                                        <div className='col-md-8'>

                                                            <iframe
                                                                width={isMobile ? "100%" : "100%"}
                                                                height={isMobile ? "100%" : "500px"}
                                                                src={getPlayerUrl(urlVideo)}
                                                                title="Transmissão"
                                                                frameBorder="0"
                                                                allowFullScreen
                                                                style={{
                                                                    border: 'none',
                                                                    ...(isMobile && {
                                                                        minHeight: "300px", // opcional para garantir altura mínima
                                                                    })
                                                                }}
                                                            ></iframe>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <h2 style={{ marginTop: 20 }}>{transmissao.nome}</h2>

                                                        </div>
                                                    </div>
                                                    {qtdConvidados > 0 ?
                                                        <div className='col-md-12'>
                                                            <h2 style={{ marginTop: 20 }}>Convidados - Limite de {qtdConvidados} convidados</h2>
                                                            <p>Adicione abaixo seus convidados. Você possui <b>{parseInt(qtdConvidados) - parseInt(salaVip.length)}</b> convidados para adicionar</p>
                                                            <div className="row">
                                                                <div class="mb-3 col-md-4">
                                                                    <label class="form-label" for="basic-icon-default-fullname">Usuários</label>
                                                                    <UsuarioSelect
                                                                        usuarios={usuarios}
                                                                        handleUsuarioSelecionado={handleUsuario}
                                                                    />
                                                                </div>
                                                                <div class="mb-3 col-md-3" style={{ marginTop: 30 }}>
                                                                    <button onClick={() => cadastraSala()} type="submit" className="btn btn-primary me-2">Adicionar</button>
                                                                </div>
                                                            </div>
                                                            <div className="table-responsive text-nowrap">
                                                                <table className="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Usuário</th>
                                                                            <th>Email</th>
                                                                            {/* <th>Remover</th> */}
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody className="table-border-bottom-0">
                                                                        {salaVip.map((sala) =>
                                                                            <tr key={sala.id}>
                                                                                <td>{sala.usuarioNome}</td>
                                                                                <td>{sala.usuarioEmail}</td>
                                                                                {/* <td>
                                                                                    <button onClick={() => removeSala(sala)} type="button" className="btn rounded-pill btn-icon btn-danger">
                                                                                        <span className="tf-icons bx bx-trash" />
                                                                                    </button>
                                                                                </td> */}
                                                                            </tr>
                                                                        )}
                                                                        {salaVip.length === 0 ?
                                                                            <p style={{ textAlign: 'center', padding: 10 }} >Sem usuarios na sala vip</p>
                                                                            :
                                                                            null
                                                                        }

                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                        :
                                                        null
                                                    }
                                                </div>
                                                :
                                                null
                                            }

                                        </div>
                                    </div>
                                    :
                                    null
                                }

                                {isModalOpen && urlVideo && <Modal onClose={closeModal} playerNumber={urlVideo} transmissao={transmissao} />}
                                {isModalOpenPix && <ModalPix textToCopy={copiaCola} qrcode={qrcode} onClose={closeModalPix} />}
                            </div>
                            <Footer />
                            <div className="content-backdrop fade" />
                        </div>
                        {/* Content wrapper */}
                    </div>
                </div>

            </div>
        </div>

    );
}